module.exports = "/images/acceso_controlado.svg?84d4e9dc50996bc29ec3fc7a5ae5eaab";